<template>
  <nav>
    <!-- Public Top Navbar -->
    <v-app-bar color="yellow darken-3 accent-4" dark app class="px-2">
      <!-- Brand Logo -->
      <v-app-bar-nav-icon class="mr-4 ml-1">
        <v-avatar>
          <v-img src="/img/favicon.png"></v-img>
        </v-avatar>
      </v-app-bar-nav-icon>

      <v-toolbar-title class="text-uppercase title font-weight-bold">
        <span>Kokkiat Management System</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        text
        rounded
        v-for="tab in tabs"
        :key="tab.text"
        router
        :to="tab.route"
        class="ma-1 hidden-xs-only"
        >{{ tab.text }}</v-btn
      >
    </v-app-bar>
  </nav>
</template>

<script>
export default {
  name: 'NavbarPublic',
  data() {
    return {
      tabs: [{ text: 'Home', route: '/' }]
    }
  }
}
</script>

<style></style>
